import Icon from '../components/Icon.vue'

Icon.register({
  podcast: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M267.4 488.6c-5.1 19-24.6 23.4-43.4 23.4-18.9 0-38.3-4.4-43.4-23.4-7.6-28.4-20.6-99.7-20.6-132.8 0-35.2 31.1-43.8 64-43.8s64 8.6 64 43.8c0 32.9-12.9 104.2-20.6 132.8zM156.9 288.6c2.7 2.6 2.4 7-0.6 9.2-9.3 6.8-16.5 15.3-21.2 25.4-1.7 3.7-6.5 4.7-9.5 1.9-28-26.3-45.5-63.6-45.5-105 0-80.8 66.9-146.2 148.2-143.9 76.2 2.2 137.9 64.2 139.8 140.4 1 42.8-16.7 81.5-45.5 108.6-3 2.8-7.7 1.8-9.4-1.9-4.8-10-11.9-18.6-21.2-25.4-3-2.2-3.3-6.6-0.6-9.2 17.8-17.4 28.9-41.7 28.9-68.6 0-54.2-45.1-98-99.8-95.9-49.7 1.9-90.1 42.2-92.1 91.9-1.2 28.4 10.1 54.3 28.8 72.6zM224 0c123.8 0 224 100.2 224 224 0 90.2-52.8 165.7-125.7 201.4-4.3 2.1-9.3-1.5-8.5-6.3 2.6-16.6 4.6-33.2 5.6-47.2 48.5-31.4 80.7-85.9 80.7-147.9 0-97.2-79.2-176.3-176.5-176-96.2 0.3-174.9 78.7-175.5 174.9-0.4 61.3 30.8 115.5 78.2 147.3 1.5 1 2.5 2.7 2.7 4.5 1.1 13.4 3 28.8 5.4 44.3 0.7 4.8-4.2 8.4-8.5 6.3-73.1-35.8-125.7-111.4-125.7-201.4 0-123.8 100.2-224 224-224zM224 160c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/podcast.js
// module id = 1650
// module chunks = 0